<!-- src/views/AcademyView.vue -->
<template>
    <div class="academy-page">
      <!-- Hero Section -->
      <div class="hero-section bg-primary text-white py-5">
        <div class="container">
          <h1 class="display-4">
            <i class="fas fa-graduation-cap me-3"></i>Academy
          </h1>
          <p class="lead">แหล่งเรียนรู้และพัฒนาทักษะด้านการค้าระหว่างประเทศ</p>
        </div>
      </div>
  
      <!-- Main Content -->
      <div class="container py-5">
        <div class="row g-4">
          <!-- Online Training -->
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="icon-wrapper bg-primary-light">
                <i class="fas fa-laptop text-primary"></i>
              </div>
              <h3>Online Training</h3>
              <p class="text-muted">การอบรมออนไลน์</p>
              <router-link to="/academy/online" class="btn btn-outline-primary">
                เรียนรู้เพิ่มเติม
                <i class="fas fa-arrow-right ms-2"></i>
              </router-link>
            </div>
          </div>
  
          <!-- Offline Training -->
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="icon-wrapper bg-success-light">
                <i class="fas fa-chalkboard-teacher text-success"></i>
              </div>
              <h3>Offline Training</h3>
              <p class="text-muted">การอบรมแบบปกติ</p>
              <router-link to="/academy/offline" class="btn btn-outline-success">
                เรียนรู้เพิ่มเติม
                <i class="fas fa-arrow-right ms-2"></i>
              </router-link>
            </div>
          </div>
  
          <!-- Process for Trading -->
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="icon-wrapper bg-warning-light">
                <i class="fas fa-exchange-alt text-warning"></i>
              </div>
              <h3>Process for Trading</h3>
              <p class="text-muted">กระบวนการสำหรับการค้า</p>
              <router-link to="/academy/process" class="btn btn-outline-warning">
                เรียนรู้เพิ่มเติม
                <i class="fas fa-arrow-right ms-2"></i>
              </router-link>
            </div>
          </div>
  
          <!-- Related Departments -->
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="icon-wrapper bg-info-light">
                <i class="fas fa-building text-info"></i>
              </div>
              <h3>Related Departments</h3>
              <p class="text-muted">หน่วยงานที่เกี่ยวข้อง</p>
              <div class="department-links">
                <a href="#" class="dept-link">
                  <i class="fas fa-store me-2"></i>
                  กระทรวงพาณิชย์
                </a>
                <a href="#" class="dept-link">
                  <i class="fas fa-industry me-2"></i>
                  กระทรวงอุตสาหกรรม
                </a>
                <a href="#" class="dept-link">
                  <i class="fas fa-leaf me-2"></i>
                  กระทรวงเกษตรและสหกรณ์
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .hero-section {
    background: linear-gradient(45deg, #0B8AC6, #06618b);
  }
  
  .service-card {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    height: 100%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    transition: transform 0.2s;
  }
  
  .service-card:hover {
    transform: translateY(-5px);
  }
  
  .icon-wrapper {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
  }
  
  .icon-wrapper i {
    font-size: 24px;
  }
  
  .bg-primary-light { background: rgba(11,138,198,0.1); }
  .bg-success-light { background: rgba(40,175,96,0.1); }
  .bg-warning-light { background: rgba(255,193,7,0.1); }
  .bg-info-light { background: rgba(23,162,184,0.1); }
  
  .department-links {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1rem;
  }
  
  .dept-link {
    color: #666;
    text-decoration: none;
    padding: 0.5rem;
    border-radius: 8px;
    transition: all 0.2s;
  }
  
  .dept-link:hover {
    background: #f8f9fa;
    color: #0B8AC6;
    padding-left: 1rem;
  }
  
  h3 {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }
  
  .btn {
    margin-top: 1rem;
  }
  </style>
  
  <script>
  export default {
    name: 'AcademyView',
    components: {
      // Add any child components here
    }
  }
  </script>